import { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { ReactComponent as Logo } from '../images/cluster-logo.svg'
import { selectPage } from '../store/selectors';
import Login from '../Auth/Login';

import styles from './AuthController.module.scss'

export default function AuthController() {

  const { subPage } = useSelector(selectPage);

  const rootComponents: {[index: string]: any} = {
    Login
  }

  const PageComponent = (subPage && rootComponents[subPage]) ? rootComponents[subPage] : {
    Primary: Fragment,
    Secondary: Fragment
  };

  return (
    <Fragment>
      <div className={styles.primaryWrapper}>
        <Logo className={styles.logo} />
        <div className={styles.title}>Breaking News | RBN Analysis | Commodity Prices</div>

        <PageComponent.Primary />
      </div>
      <div className={styles.secondaryWrapper}>
        <PageComponent.Secondary />
      </div>
    </Fragment>
  )
}